// src/components/MainLayout.js
import useAuth from '../hooks/useAuth';
import { useLocation } from 'react-router-dom';
import ToastContainer from './common/ToastContainer';
import Header from './layout/Header'; // ✅ Новый компонент шапки
import Footer from './layout/Footer'; // ✅ Новый компонент подвала
import LoadingSpinner from './common/LoadingSpinner';

const MainLayout = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const hideNav = location.pathname === '/login';

  return (
    <>
      {/* === Компоненты интерфейса === */}
       {/* Показываем шапку, если не на /login */}

      <div className="container-fluid content-block">
          {!hideNav && <Header />}
        {isAuthenticated !== null ? children : <LoadingSpinner text="Загрузка страницы..." />}

      </div>

      {/* Подвал — можно показывать всегда */}
      <Footer />

      {/* Всплывающие уведомления */}
      <ToastContainer />

    </>
  );
};

export default MainLayout;


